export const retentionRatioId = 'retention_ration';
export const carrierOneId = 'carrier_one';
export const carrierOneLossId = 'carrier_one_loss';
export const carrierTwoId = 'carrier_two';
export const carrierTwoLossId = 'carrier_two_trailing_loss';
export const carrierThreeId = 'carrier_three';
export const carrierThreeLossId = 'carrier_three_loss';
export const businessEntityTypeId = 'business_entity_type';
export const principalNpnId = 'principal_npn';
export const hasAgencyLicenseId = 'producer_license_in_agency_name';
export const agencyNameId = 'agency_name';
export const agencyNpnId = 'producer_license_in_agency_name_npn';
export const agencyStatesLicensedId = 'agency_states_licensed';
/**
 * Stored enrollment IDs to activate as direct appointments. Activating direct appointments
 * would prevent users from resuming Welcome flow to finish sub-appointment steps.
 */
export const queuedDirectAppointmentEnrollmentsId =
  'queued_direct_appointment_enrollments';
/**
 * Stored enrollment IDs to activate as sub-appointments. Activating sub-appointments requires
 * compliance steps to be complete, users may resume Welcome flow to finish sub-appointment steps.
 */
export const queuedSubAppointmentEnrollmentsId =
  'queued_sub_appointment_enrollments';
export const skipInstantEnrollmentDefaultForIds =
  'skip_instant_enrollment_default_for_ids';

// Travelers
export enum TravelersComplianceQuestionKeys {
  HasDirectAppointment = 'travelers_has_direct_appointment',
  YearsCommercialExperience = 'travelers_years_commercial_experience',
  TopCarriers = 'travelers_top_carriers_by_volume',
  TopIndustries = 'travelers_top_industries_by_policy_count',
  TotalPremium = 'travelers_total_written_premium',
  CommercialPercentage = 'travelers_commercial_percentage',
  WCPremiumPercentage = 'travelers_percentage_wc_premium',
  CaptiveCarrierAffiliated = 'travelers_captive_carrier_affiliated',
  AgencyUserAdministratorName = 'travelers_agency_user_administrator_name',
  AgencyUserAdministratorEmail = 'travelers_agency_user_administrator_email',
}

// Westfield
export enum WestfieldComplianceQuestionKeys {
  PriorAppointmentRequest = 'westfield_prior_appointment',
  MinimumOneYearExperience = 'westfield_minimum_one_year_experience',
  PhysicalLocation = 'westfield_physical_location',
  OnboardingTraining = 'westfield_onboarding_training',
}
